export default __webpack_public_path__ + "static/media/logo-dpec-01.43be18da.svg";